import React from 'react';
import PropTypes from 'prop-types';
import { object, mixed, string } from 'yup';
import { Card, CardFooter, CardBody } from 'reactstrap';
import { Button, Form } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';
import kebabcaseKeys from 'kebabcase-keys';
import { toast } from 'react-toastify';
import { parse, format } from 'date-fns';

import { authorizedPyInstance as Py } from '~/utils';

import Fields from './Fields';

const validationSchema = object().shape({
  medicationUid: mixed().nullable().required(),
  comments: string(),
  patientUid: mixed().required(),
});

const initialValues = {
  medicationUid: '',
  comments: '',
};

const handleSubmit = (v, b) => {
  const p = [
    'medicationUid',
    'patientUid',
    'dosage',
    'frequency',
    'startedDate',
    'finishedDate',
    'isPrimary',
    'isStillTaking',
    'isPrescription',
    'medicationRoutes',
    'patientReportedImprovement',
    'reliefRating',
    'reliefDuration',
    'comments',
  ].reduce((a, m) => {
    console.log(a, m, v[m]);

    if (m.endsWith('Uid')) {
      return {
        ...a,
        [m]: Array.isArray(v[m]) ? v[m].map(r => r.id) : v[m].id || v[m].value || v[m],
      };
    } else if (m.endsWith('Date')) {
      return {
        ...a,
        [m]: format(parse(v[m]), 'YYYY-MM-DD'),
      };
    } else if (Array.isArray(v[m])) {
      return {
        ...a,
        [m]: v[m].map(r => r.id || r.value || r),
      };
    } else if (typeof v[m] === 'object') {
      return {
        ...a,
        [m]: v[m].id || v[m].value,
      };
    }

    return {
      ...a,
      [m]: v[m],
    };
  }, {});

  const method = v.id ? 'put' : 'post';
  const url = `api/data/public/patient-medication${v.id ? `/${v.id}` : ''}`;

  console.log(method, url, p, v, b);

  return Py[method](url, kebabcaseKeys(p));
};

const MedicationForm = ({ data, disabled }) => {
  const history = useHistory();

  return (
    <Form
      displayName="MedicationForm"
      validationSchema={validationSchema}

      initialValues={{
        ...initialValues,
        ...data,
      }}

      onSubmit={(v, b) =>
        handleSubmit(v, b)
          .then(() => {
            toast.success('Successfully Saved!');
            history.push(`/patients/${v.patientUid.id}/medications`);
          })
    .catch(e => b.setErrors({ server: e.errors }))
          .finally(() => b.setSubmitting(false))

      }
    >
      {({
        isSubmitting,
      }) => (
        <Card>
          <CardBody className="p-0">
            <Fields disabled={disabled} />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="button"
                color="tertiary"
                outline
                icon="times"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>

              <Button type="submit" disabled={disabled || isSubmitting}>
                {isSubmitting ? 'Working ...' : 'Save'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </Form>
  );
};

MedicationForm.propTypes = {
  data: PropTypes.shape(),
  disabled: PropTypes.bool,
};

MedicationForm.defaultProps = {
  data: {},
  disabled: false,
};

export default MedicationForm;
